import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './share-modul/components/login/login.component';
import { SignupComponent } from "./share-modul/components/signup/signup.component";
import { ForgotPasswordComponent } from "./share-modul/components/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./share-modul/components/reset-password/reset-password.component";
import { LoginGuard } from "./guard/auth-related.guard.component";
import { LoginWithRefreshTokenComponent } from './share-modul/components/login-with-refresh-token/login-with-refresh-token.component';
import { AuthGuard } from './guard/guard.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login/:refresh-token',component: LoginWithRefreshTokenComponent},
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  // { path: 'signup', component: SignupComponent, canActivate: [LoginGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [LoginGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [AuthGuard] },
  { path: 'host/users', component: ResetPasswordComponent, canActivate: [LoginGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
